import React from 'react';
import FormOne from './FormOne';
import FormTwo from './FormTwo';
import FormThree from './FormThree';
// import FormFour from './FormFour';

export default function CampaignForm({ step }) {

  function switchForm() {
    switch (step) {
      case 0:
        return <FormOne />;
    
      case 1:
        return <FormTwo />;
    
      case 2:
        return <FormThree />;
    
      // case 3:
      //   return <FormFour />;
    
      default:
        return <></>;
    }
  }

  return (
    <>
      {
        switchForm()
      }
    </>
  )
}
